import React from 'react';
import './DetailedIndicatorEntry.css'

import { ChartData } from 'components/Chart/Chart';
import ChartContainer from 'components/Chart/ChartContainer';
import translationsJson from 'data/translations.json';
import { formatValue } from 'lib/Utils';
import colors from 'data/colorsDetail.json';
import { IndicatorDataEntry } from 'components/RouteHandler/RouteHandler';

const translations: Translations = translationsJson;
interface Props {
    dataDefinition: IndicatorDataEntry;
    data: ChartData;
}

class DetailedIndicatorEntry extends React.Component<Props, {}> {
    render() {
        let indexOfPeriod = 0;
        let periodFound = false;

        for (let schema of this.props.dataDefinition.schema) {
            if ("period" in schema) {
                periodFound = true;
                break;
            } else {
                indexOfPeriod += Math.max(1, schema[Object.keys(schema)[0]]!.length);
            }
        }

        const dataEntry = this.props.dataDefinition.data[0];
        console.log("data entry:", dataEntry);
        const infoCards = [];
        let index = 0;

        for (let schema of this.props.dataDefinition.schema) {
            if ("period" in schema) {
                index++;
                continue;
            }

            const key = Object.keys(schema)[0];

            if (schema[key].length === 0) {
                infoCards.push(
                    <div className='data-card' key={index}>
                        <div className='data-card-title'>{translations[key][window.lang]}</div>
                        <div className='data-card-value'>{dataEntry.values[index]}</div>
                        {
                            periodFound &&
                            <div className='data-card-period' key={`${index}-period`}>{"(" + formatValue(dataEntry.values[indexOfPeriod], dataEntry.numDigits[indexOfPeriod], window.lang, translations) + ")"}</div>
                        }
                    </div>
                )
                index++;
            } else {
                if (key === "sex") {
                    infoCards.push(
                        <div className='data-card' key={index}>
                            <div className='data-card-title' key={`${index}-c0`}>{translations[schema[key][0]][window.lang]}</div>
                            <div className='data-card-value' key={`${index}-c1`}>{formatValue(dataEntry.values[index], dataEntry.numDigits[index], window.lang, translations)}</div>
                            {
                                periodFound &&
                                <div className='data-card-period' key={`${index}-period`}>{"(" + formatValue(dataEntry.values[indexOfPeriod], dataEntry.numDigits[indexOfPeriod], window.lang, translations) + ")"}</div>
                            }
                        </div>
                    )
                    index++;
                    infoCards.push(
                        <div className='data-card' key={index}>
                            <div className='data-card-title' key={`${index}-c0`}>{translations[schema[key][1]][window.lang]}</div>
                            <div className='data-card-value' key={`${index}-c1`}>{formatValue(dataEntry.values[index], dataEntry.numDigits[index], window.lang, translations)}</div>
                            {
                                periodFound &&
                                <div className='data-card-period' key={`${index}-period`}>{"(" + formatValue(dataEntry.values[indexOfPeriod], dataEntry.numDigits[indexOfPeriod], window.lang, translations) + ")"}</div>
                            }
                        </div>
                    )
                    index++;
                } else {
                    const cardContent = [];
                    cardContent.push(<div className='data-card-title' key={`${index}-c0`}>{`${translations[key][window.lang]} (${translations[schema[key][0]][window.lang]})`}</div>)
                    cardContent.push(<div className='data-card-value' key={`${index}-c1`}>{formatValue(dataEntry.values[index], dataEntry.numDigits[index], window.lang, translations)}</div>)
                    index++;
                    for (let i = 1; i < schema[key].length; i++) {
                        cardContent.push(
                            <div className='data-card-addition' key={`${index}-c${i + 1}`}>
                                <span>
                                    {translations[schema[key][i]][window.lang] + ": "}
                                    <span>{formatValue(dataEntry.values[index], dataEntry.numDigits[index], window.lang, translations)}</span>
                                </span>
                            </div>
                        )
                        index++;
                    }
                    if (periodFound)
                        cardContent.push(<div className='data-card-period' key={`${index}-period`}>{"(" + formatValue(dataEntry.values[indexOfPeriod], dataEntry.numDigits[indexOfPeriod], window.lang, translations) + ")"}</div>);
                    infoCards.push(<div className='data-card' key={index}>{cardContent}</div>);
                }
            }
        }

        return (
            <>
                <div className='detail-title'>{translations[this.props.data.name][window.lang]}</div>
                <div className='detail-source'>
                    {translations.source[window.lang] + ": " + translations[this.props.dataDefinition.source][window.lang]}
                </div>
                <div className='data-card-container'>
                    {infoCards}
                </div>
                <ChartContainer data={(this.props.data) as ChartData} loadData={() => { }} title={this.props.data.name} source={translations.source[window.lang] + ": " + translations[this.props.dataDefinition.source][window.lang]} colors={colors} />
                <a className='more-link' href={window.lang === "de" ? "https://astat.provinz.bz.it/de/konjunkturbarometer.asp" : "https://astat.provincia.bz.it/it/barometro-congiunturale.asp"} target="_top">
                    {translations.additionalData[window.lang]} <b> {translations.additionalDataASTATECO[window.lang]} </b>
                </a>
            </>
        );
    }
}

export default DetailedIndicatorEntry;